module.exports = __webpack_public_path__ + "img/rainy-3.c17e7a5d.svg";